// eslint-disable-next-line max-len
import { VehicleMaintenanceScheduleServiceDue } from '@quorum/models/xs-resource';

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ServicesDueState extends EntityState<VehicleMaintenanceScheduleServiceDue> {
  roHistory: any;
  roHistoryLoading: boolean;
  roHistoryError: string | null;
  loaded: boolean;
  error: string | null;
}

export interface ServicesDueLoadStatus {
  loaded: boolean;
  count: number;
  error: string | null;
}

export const servicesDueAdapter: EntityAdapter<VehicleMaintenanceScheduleServiceDue> = createEntityAdapter<
  VehicleMaintenanceScheduleServiceDue
>({
  selectId: (serviceDue: VehicleMaintenanceScheduleServiceDue) => serviceDue.id
});

export const initialState: ServicesDueState = servicesDueAdapter.getInitialState({
  roHistory: null,
  roHistoryLoading: null,
  roHistoryError: null,
  loaded: false,
  error: null
});
export const servicesDueFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const servicesDueSelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue
);
export const roHistorySelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue.roHistory
);

export const roHistoryIsLoadingSelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue.roHistoryLoading
);
export const roHistoryErrorSelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue.roHistoryError
);
export const servicesDueLoadedSelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue.loaded
);
export const servicesDueErrorSelector = createSelector(
  servicesDueFeatureSelector,
  (state: any) => state.servicesDue.error
);
export const { selectIds, selectEntities, selectAll, selectTotal } = servicesDueAdapter.getSelectors(
  servicesDueSelector
);
